import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiAdminUsersService } from '../admin-users/api/api-admin-users.service';
import { ApiAdminUsersLoginResponse } from '../../models/admin-users/responses/api-admin-users-login-response.model';
import { AdminUserLogged } from '../../models/admin-users/admin-user-logged.model';
import { storageConfig } from '../../config/storage.config';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
    public currentAdminUserLoggedSubject = new Subject<void>();

    private isLoginInProgress : boolean = false;

    private adminUserLogged : AdminUserLogged | undefined = undefined;

    constructor(private router: Router, private apiAdminUsersService : ApiAdminUsersService) {
       const adminUserStored = localStorage.getItem(storageConfig.adminUserLogged);
       this.adminUserLogged = adminUserStored ? JSON.parse(adminUserStored) : undefined;
    }

    login(email: string, password: string): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this.isLoginInProgress = true;

            this.apiAdminUsersService.loginAdminUser(email, password).then(
                (loginResponse : ApiAdminUsersLoginResponse) => {
                    this.isLoginInProgress = false;
                    this.adminUserLogged = new AdminUserLogged();
                    this.adminUserLogged.userId = loginResponse.user_id;
                    this.adminUserLogged.email = loginResponse.email;
                    this.adminUserLogged.sessionToken = loginResponse.user_session_token;

                    localStorage.setItem(storageConfig.adminUserLogged, JSON.stringify(this.adminUserLogged));
                    
                    this.emitAdminUserLogged();
                    resolve(true);
            }, error => {
                this.isLoginInProgress = false;
                reject(error); 
            });
        });
    }

    logout() {
        localStorage.setItem(storageConfig.adminUserLogged, "");
        this.adminUserLogged = undefined;
        this.emitAdminUserLogged();
        this.router.navigate(['/login']);
    }
    
    public getCurrentUserEmail(): String | undefined {
        if (this.adminUserLogged !== undefined)
            return this.adminUserLogged.email;

        return undefined;
    }

    public getCurrentUserSessionToken(): String | undefined {
        if (this.adminUserLogged !== undefined)
            return this.adminUserLogged.sessionToken;

        return undefined;
    }

    // Check if the user is logged
    isUserLogged(): boolean {
        if (this.adminUserLogged !== undefined
            && this.adminUserLogged.userId > 0)
            return true;
        return false;
    }

    private emitAdminUserLogged() {
        this.currentAdminUserLoggedSubject.next();
    }
}
